/** French number-line prompt (ADR 0051 part 3). */
export const numberLinePrompts = {
    arrow: () => `Quel nombre la flèche indique-t-elle ?`,
};
